// 29 Schengen Area countries with flag emojis + ISO codes
export const SCHENGEN_COUNTRIES = [
  { name: "Austria", code: "AT", flag: "🇦🇹" },
  { name: "Belgium", code: "BE", flag: "🇧🇪" },
  { name: "Bulgaria", code: "BG", flag: "🇧🇬" },
  { name: "Croatia", code: "HR", flag: "🇭🇷" },
  { name: "Czech Republic", code: "CZ", flag: "🇨🇿" },
  { name: "Denmark", code: "DK", flag: "🇩🇰" },
  { name: "Estonia", code: "EE", flag: "🇪🇪" },
  { name: "Finland", code: "FI", flag: "🇫🇮" },
  { name: "France", code: "FR", flag: "🇫🇷" },
  { name: "Germany", code: "DE", flag: "🇩🇪" },
  { name: "Greece", code: "GR", flag: "🇬🇷" },
  { name: "Hungary", code: "HU", flag: "🇭🇺" },
  { name: "Iceland", code: "IS", flag: "🇮🇸" },
  { name: "Italy", code: "IT", flag: "🇮🇹" },
  { name: "Latvia", code: "LV", flag: "🇱🇻" },
  { name: "Liechtenstein", code: "LI", flag: "🇱🇮" },
  { name: "Lithuania", code: "LT", flag: "🇱🇹" },
  { name: "Luxembourg", code: "LU", flag: "🇱🇺" },
  { name: "Malta", code: "MT", flag: "🇲🇹" },
  { name: "Netherlands", code: "NL", flag: "🇳🇱" },
  { name: "Norway", code: "NO", flag: "🇳🇴" },
  { name: "Poland", code: "PL", flag: "🇵🇱" },
  { name: "Portugal", code: "PT", flag: "🇵🇹" },
  { name: "Romania", code: "RO", flag: "🇷🇴" },
  { name: "Slovakia", code: "SK", flag: "🇸🇰" },
  { name: "Slovenia", code: "SI", flag: "🇸🇮" },
  { name: "Spain", code: "ES", flag: "🇪🇸" },
  { name: "Sweden", code: "SE", flag: "🇸🇪" },
  { name: "Switzerland", code: "CH", flag: "🇨🇭" },
];

export function flagFor(name) {
  const c = SCHENGEN_COUNTRIES.find((c) => c.name === name);
  return c ? c.flag : "";
}

export function codeFor(name) {
  const c = SCHENGEN_COUNTRIES.find((c) => c.name === name);
  return c ? c.code : "";
}

export function exampleFileUrl(path) {
  const base = process.env.REACT_APP_BACKEND_URL;
  return `${base}/api/packages/example/file?path=${encodeURIComponent(path)}`;
}
